import { render, staticRenderFns } from "./ReportCompDetail.vue?vue&type=template&id=58c044fc&scoped=true&"
import script from "./ReportCompDetail.vue?vue&type=script&lang=js&"
export * from "./ReportCompDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReportCompDetail.vue?vue&type=style&index=0&id=58c044fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c044fc",
  null
  
)

export default component.exports